/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, output, TemplateRef, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'bn-web-ui-clearbutton-select-template',
  templateUrl: './clearbutton-select-template.component.html',
  imports: [FormsModule, FaIconComponent],
})
export class ClearButtonSelectTemplateComponent {
  readonly clearButton = viewChild.required<TemplateRef<any>>('clearButton');
  readonly textClearButton = viewChild.required<TemplateRef<any>>('textClearButton');

  // Event that triggers clear all at parent model
  readonly clear = output<void>();

  // Emit clear all event
  emitClear(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.clear.emit();
  }
}
